import { EUserAccessPart, IInvitationDto, IRoleDto, IUserDto, IUserInfoDto } from "@kuika/kuika-cl-model";
import { EInvitationStatus } from "@kuika/kuika-cl-model/src/dtos/user.dto";
import { IWorkspaceRoleDto } from "@kuika/kuika-cl-model/src/dtos/workspace-role.dto";
import dayjs from "dayjs";
import * as React from "react";
import { ChangeEvent } from "react";
import { connect } from "react-redux";
import { PaymentService } from "../../../../services/payment-service";
import { RoleService } from "../../../../services/role-service";
import { ScreenService } from "../../../../services/screen-service";
import { UserService } from "../../../../services/user-service";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { IWithHistoryProp, withHistory } from "../../../../shared/hoc/with-history";
import { withManagement } from "../../../../shared/hoc/with-management";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { showDomainAccessRequiredModal } from "../../../../store/domain-access-modal/actions";
import { DeleteModal } from "../../../common/delete-modal";
import { MemberInfo } from "../../../design-tools/header/member-info-modal";
import KuikaAvatar, { getIdentitySeed } from "../../../ui-kit/kuika-avatar/kuika-avatar";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaDropdownMenu from "../../../ui-kit/kuika-dropdown-menu/kuika-dropdown-menu";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";
import KuikaRoleBadge from "../../../ui-kit/kuika-role-badge/kuika-role-badge";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTable, { KuikaTableColumn } from "../../../ui-kit/kuika-table/kuika-table";
import KuikaH4 from "../../../ui-kit/typography/H4/H4";
import { TransferOwnershipModal } from "./transfer-ownership-modal";
import { UserPage } from "./user-page";

declare let window: any;
export interface IUsersState {
  userList: IUserDto[];
  filteredUserList: IUserDto[];
  userToDelete: IUserInfoDto | IUserDto;
  userToEdit: IUserInfoDto | IUserDto;
  triggerUserDeleteModal: boolean;
  isSubmitButtonLoading: boolean;
  isUserModalOpen: boolean;
  isTransferOwnershipModalOpen: boolean;
  isManageMemberModalOpen: boolean;
  isDataLoading: boolean;
  isDeleteInvitationModalActive: boolean;
  selectedUser: IUserInfoDto | IUserDto;
  roleList: IRoleDto[];
  filteredRoleList: IRoleDto[];
  activeTab: string;
  searchText: string;
  maxUserCount: number;
  invalidUsernameIndexes: number[];
  /** The member the table should walk to and light up after an edit, or null. */
  revealUserId: string | null;
}

export interface IUsersProps {
  showDomainAccessRequiredModal: (actionName: string | string[]) => void;
}

class Users extends React.PureComponent<IUsersProps & IWithContextProp & IWithHistoryProp, IUsersState> {
  constructor(props: IUsersProps & IWithContextProp & IWithHistoryProp) {
    super(props);
    this.loadUserList = this.loadUserList.bind(this);
    this.state = {
      triggerUserDeleteModal: false,
      userToDelete: {} as IUserInfoDto,
      userToEdit: {} as IUserInfoDto,
      userList: [],
      filteredUserList: [],
      isSubmitButtonLoading: false,
      isUserModalOpen: false,
      isTransferOwnershipModalOpen: false,
      isDataLoading: false,
      isDeleteInvitationModalActive: false,
      isManageMemberModalOpen: false,
      selectedUser: {} as IUserInfoDto,
      roleList: [],
      filteredRoleList: [],
      activeTab: "1",
      searchText: "",
      maxUserCount: 99999,
      invalidUsernameIndexes: [],
      revealUserId: null
    };
  }

  async componentDidMount() {
    await this.load();
  }

  componentDidUpdate(prevProps) {
    const dataChangedQuery = new URLSearchParams(this.props.navigator.location.search).get("dataChanged");
    if (dataChangedQuery === "true") {
      this.load();
    }
  }

  load = async () => {
    await this.loadUserList();
    await this.loadRoleList();
    try {
      const currentSub = await (await PaymentService.GetCurrentSubscription()).data;
      if (
        currentSub &&
        currentSub.id &&
        currentSub.items &&
        currentSub.items.length > 0 &&
        currentSub.items[0].quantity > 1 &&
        (window?.location?.hostname == "preprod.kuika.com" ||
          window?.location.hostname == "platform.kuika.com" ||
          window?.location.hostname == "localhost")
      ) {
        this.setState({ maxUserCount: currentSub.items[0].quantity });
      } else if (!currentSub) {
        this.setState({ maxUserCount: 1 });
      }
    } catch {}
  };

  async loadUserList() {
    if (this.props.navigator.location.search.includes("dataChanged=true")) {
      this.props.navigator.navigate(this.props.navigator.location.pathname);
    }
    this.setState({ isDataLoading: true });
    try {
      const userListx: IUserDto[] = (await (await UserService.GetUsersByDomainId()).data) as IUserDto[];
      this.setState({
        // aktif arama filtresi korunmalı, yoksa liste ile arama kutusu tutarsız kalıyor
        filteredUserList: this.getFilteredUsers(userListx, this.state.searchText),
        userList: userListx,
        isDataLoading: false
      });
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      this.setState({ isDataLoading: false });
    }
  }

  openUserModalForCreate = () => {
    const accessName = "Seat";
    if (KMainFunctions.isDomainHasAccess(accessName, this.state.maxUserCount <= this.state.userList.length) === false) {
      this.props.showDomainAccessRequiredModal(accessName);
      return;
    }

    this.setState({ isUserModalOpen: true, userToEdit: {} as IUserInfoDto });
  };

  openUserModalForEdit = (user) => {
    this.setState({ isUserModalOpen: true, userToEdit: user });
  };

  openTransferOwnershipModal = (user) => {
    this.setState({ isTransferOwnershipModalOpen: true, userToEdit: user });
  };

  closeUserModal = (revealUserId?: string) => {
    this.setState({ isUserModalOpen: false, revealUserId: revealUserId ?? null }, this.loadUserList);
  };

  deleteUser() {
    try {
      ScreenService.LeaveScreenByUserId(this.state.userToDelete.id);

      UserService.Delete(this.state.userToDelete.id).then((res) => {
        if (res === true) {
          this.loadUserList();
        }
      });
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  deleteInvitation = async () => {
    this.setState({ isDataLoading: true, isDeleteInvitationModalActive: false });
    try {
      const res = await UserService.DeleteInvitation(this.state.selectedUser.id);
      if (res.status === 200) {
        this.loadUserList();
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  };

  triggerDeleteRoleModal = (e, user) => {
    const event = e?.domEvent ?? e;
    event?.preventDefault?.();
    event?.stopPropagation?.();
    this.setState({ triggerUserDeleteModal: true, userToDelete: user });
  };

  triggerDeleteInvitationModal = (e, user) => {
    const event = e?.domEvent ?? e;
    event?.preventDefault?.();
    event?.stopPropagation?.();
    this.setState({ isDeleteInvitationModalActive: true, selectedUser: user });
  };

  isTransferOwnershipVisible = (user) => {
    const isDomainOwner = this.props.context.userInfo.isDomainOwner;
    const isDomainAuthorizationEnabled = KMainFunctions.isDomainAuthorizationEnabled();
    const hasUserAccessTransferOwnership = KMainFunctions.hasUserAccessInWorkspace(
      EUserAccessPart.TransferProjectOwnership
    );
    return user.isDomainOwner && isDomainAuthorizationEnabled && hasUserAccessTransferOwnership && isDomainOwner;
  };

  resendInvitation = async (user: IUserDto) => {
    const roleArr: string[] = [];
    if (this.isOnlyRoleFullAccess()) {
      const role: string = this.state.roleList[0].id;
      roleArr.push(role);
    }

    const obj = {} as IInvitationDto;
    obj.usernames = [];
    obj.usernames.push(user.username);

    await UserService.Invite(obj);
    KMainFunctions.displaySuccessNotification(`Invitation successfully resent to ${obj.usernames}.`);
  };

  isOnlyRoleFullAccess = () => {
    if (this.state.roleList.length === 1 && this.state.roleList.find((x) => x.name === "Full Access")) {
      return true;
    }
    return false;
  };

  getFilteredUsers = (userList: IUserDto[], searchText: string): IUserDto[] => {
    if (!searchText) {
      return userList ?? [];
    }
    return (
      userList?.filter(
        (x) =>
          x.username?.indexOf(searchText) > -1 ||
          x.firstName?.indexOf(searchText) > -1 ||
          x.lastName?.indexOf(searchText) > -1
      ) ?? []
    );
  };

  filterUsers = (event: ChangeEvent<HTMLInputElement>) => {
    const searchFor: string = event.currentTarget.value;
    this.setState({ filteredUserList: this.getFilteredUsers(this.state.userList, searchFor), searchText: searchFor });
  };

  filterRoles = (event: ChangeEvent<HTMLInputElement>) => {
    const searchFor = event.currentTarget.value;
    const tmp = this.state.roleList?.filter((x) => x.name?.indexOf(searchFor) > -1);
    this.setState({ filteredRoleList: tmp, searchText: event.currentTarget.value });
  };

  async loadRoleList() {
    this.setState({ isDataLoading: true });
    try {
      const roleListx: IRoleDto[] = (await (await RoleService.GetAll()).data) as IRoleDto[];
      this.setState({ filteredRoleList: roleListx, roleList: roleListx, isDataLoading: false });
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      this.setState({ isDataLoading: false });
    }
  }

  deleteUserSearchText = () => {
    this.setState({ searchText: "" }, this.loadUserList);
  };

  deleteRoleSearchText = () => {
    this.loadRoleList();
    this.setState({ searchText: "" });
  };

  openManageMemberModal = async (e, user) => {
    const event = e?.domEvent ?? e;
    event?.preventDefault?.();
    event?.stopPropagation?.();
    this.setState({ isManageMemberModalOpen: true, selectedUser: user });
  };

  closeManageMemberModal = async () => {
    this.setState({ isManageMemberModalOpen: false });
    await this.loadUserList();
  };

  getTableColumns = (): KuikaTableColumn<IUserDto>[] => {
    const isDomainAuthorizationEnabled = KMainFunctions.isDomainAuthorizationEnabled();
    const columns: KuikaTableColumn<IUserDto>[] = [
      {
        id: "fullName",
        accessorFn: (row) => row.firstName ?? "",
        enableSorting: true,
        width: 200,
        header: () => "Full name",
        cell: (record) => {
          const fullName =
            record.firstName !== null && record.lastName !== null ? `${record.firstName} ${record.lastName}` : "";
          const photoUrl =
            record.username === this.props.context.userInfo.username
              ? window.profilePhoto || record.profilePhotoUrl
              : record.profilePhotoUrl;
          const initials = KMainFunctions.getUserLettersToShow(record);
          return (
            <div className="kuika_project_table_name_hover" style={{ display: "flex", alignItems: "center", gap: 16 }}>
              {/* Two hand-built circles — an `img` and a `div` painted `#E6E7EB` with
                  `#7A8499` letters — where the primitive does both and knows this person's
                  colour. */}
              <KuikaAvatar size={36} src={photoUrl} seed={getIdentitySeed(record)} aria-label={`${fullName} avatar`}>
                {initials}
              </KuikaAvatar>
              <div className="kuika_project_table_name_hover">
                <span>{fullName}</span>
              </div>
            </div>
          );
        }
      },
      {
        id: "username",
        accessorKey: "username",
        enableSorting: true,
        width: 300,
        header: () => "Email",
        cell: (record) => (
          <div className="kuika_project_table_name_hover">
            <label style={{ color: "#7A8499", fontSize: 12, fontWeight: 500 }}>{record.username}</label>
          </div>
        )
      },
      {
        id: "registrationDate",
        accessorFn: (row: any) => row.registrationDate ?? "",
        enableSorting: true,
        width: 200,
        header: () => "Registration Date",
        cell: (record) => {
          const rd = (record as any).registrationDate as string | undefined;
          return (
            <div className="kuika_project_table_name_hover">
              <label style={{ color: "#7A8499", fontSize: 12, fontWeight: 500 }}>
                {rd && !rd.startsWith("0001") ? dayjs(rd).format("LL") : ""}
              </label>
            </div>
          );
        }
      },
      ...(isDomainAuthorizationEnabled
        ? [
            {
              id: "roles",
              accessorFn: (row: IUserDto) => row.roles?.map((r) => r.name).join(", ") ?? "",
              enableSorting: false,
              width: 200,
              header: () => "Role",
              cell: (record: IUserDto) => (
                <div className="kuika-flex-wrap kuika-flex--gap-xs">
                  {record?.roles?.map((role: IWorkspaceRoleDto) => (
                    <KuikaRoleBadge key={role.id} role={role.name} />
                  ))}
                </div>
              )
            } as KuikaTableColumn<IUserDto>
          ]
        : []),
      {
        id: "workingOn",
        header: () => "Working on",
        width: 120,
        cell: (record: IUserDto) =>
          record.invitationStatusId !== null ? (
            record.invitationStatusId === EInvitationStatus.Accepted ? (
              <span className="kuika_user-list__table__info-box--green">{record.invitationStatus}</span>
            ) : record.invitationStatusId === EInvitationStatus.Rejected ? (
              <span className="kuika_user-list__table__info-box--red">{"Declined"}</span>
            ) : (
              record.invitationStatusId === EInvitationStatus.Waiting && (
                <span className="kuika_user-list__table__info-box--yellow">{record.invitationStatus}</span>
              )
            )
          ) : (
            <span>Apps ({record.projectsCount})</span>
          )
      },
      {
        id: "actions",
        header: () => <div className="kuika_user-list__table__right" />,
        align: "right",
        width: 60,
        cell: (record: IUserDto) => {
          const hasAccessEditUser = KMainFunctions.hasUserAccessInWorkspace(EUserAccessPart.AddEditUser);
          const hasAccessDeleteUser = KMainFunctions.hasUserAccessInWorkspace(EUserAccessPart.DeleteUser);
          const isDomainAuthorizationEnabled = KMainFunctions.isDomainAuthorizationEnabled();

          if (record.invitationStatus === null) {
            const showForMember =
              this.isTransferOwnershipVisible(record) ||
              ((hasAccessEditUser || hasAccessDeleteUser) && isDomainAuthorizationEnabled && !record.isDomainOwner) ||
              (!isDomainAuthorizationEnabled && !record.isDomainOwner);
            if (!showForMember) return null;

            const options = [
              ...(hasAccessEditUser
                ? [
                    {
                      label: "Manage Member",
                      value: "manage",
                      onClick: (e: any) => this.openManageMemberModal(e, record)
                    }
                  ]
                : []),
              ...(hasAccessDeleteUser
                ? [
                    {
                      label: "Remove",
                      value: "remove",
                      danger: true,
                      onClick: (e: any) => this.triggerDeleteRoleModal(e, record)
                    }
                  ]
                : [])
            ];

            return (
              <div className="kuika_user-list__table__right">
                <KuikaDropdownMenu options={options} overlayClassName="kuika_profile__workspace-role-dropdown">
                  <KuikaButton
                    type="tertiary"
                    size="sm"
                    isIcon
                    className="kuika_table_dot_menu"
                    data-testid={record.isDomainOwner ? "workspaceOwnerActionMenuButton" : "userRowActionMenuButton"}
                  >
                    <KuikaSvg name="dots" width={16} height={16} pointer />
                  </KuikaButton>
                </KuikaDropdownMenu>
              </div>
            );
          }

          const canResend = KMainFunctions.hasUserAccessInWorkspace(EUserAccessPart.InviteUser);
          const canDeleteInvitation = KMainFunctions.hasUserAccessInWorkspace(EUserAccessPart.DeleteUserInvitation);
          const options = [
            ...(canResend
              ? [
                  {
                    label: "Resend Invitation",
                    value: "resend",
                    onClick: () => this.resendInvitation(record)
                  }
                ]
              : []),
            ...(canDeleteInvitation
              ? [
                  {
                    label: "Delete",
                    value: "delete",
                    danger: true,
                    onClick: (e: any) => this.triggerDeleteInvitationModal(e, record)
                  }
                ]
              : [])
          ];

          return (
            <div className="kuika_user-list__table__right">
              <KuikaDropdownMenu options={options} overlayClassName="kuika_profile__workspace-role-dropdown">
                <KuikaButton
                  type="tertiary"
                  size="sm"
                  isIcon
                  className="kuika_table_dot_menu"
                  data-testid="invitationRowActionMenuButton"
                >
                  <KuikaSvg name="dots" width={16} height={16} pointer />
                </KuikaButton>
              </KuikaDropdownMenu>
            </div>
          );
        }
      }
    ];

    return columns;
  };

  render() {
    const hasAccessInvite = KMainFunctions.hasUserAccessInWorkspace(EUserAccessPart.InviteUser);
    const hasAccessAddEditUser = KMainFunctions.hasUserAccessInWorkspace(EUserAccessPart.AddEditUser);

    return (
      <>
        {this.state && hasAccessAddEditUser && (
          <>
            <UserPage
              user={this.state.userToEdit}
              isUserModalOpen={this.state.isUserModalOpen}
              closeModal={this.closeUserModal}
              users={this.state.userList}
            ></UserPage>
            <TransferOwnershipModal
              user={this.state.userToEdit}
              isModalOpen={this.state.isTransferOwnershipModalOpen}
              closeModal={(shouldRefresh: boolean) => {
                this.setState({ isTransferOwnershipModalOpen: false });
                if (shouldRefresh) {
                  this.loadUserList();
                }
              }}
              userList={this.state.userList}
            ></TransferOwnershipModal>
            {this.state.isManageMemberModalOpen && (
              <MemberInfo
                userId={this.state.selectedUser?.id}
                showModal={this.state.isManageMemberModalOpen}
                closeModal={this.closeManageMemberModal}
                updateUserList={() => this.loadUserList()}
              />
            )}
            <DeleteModal
              itemName={this.state.userToDelete.username}
              triggerModal={this.state.triggerUserDeleteModal}
              deleteItem={() => this.deleteUser()}
              deleteType={"User"}
              closeModal={() => this.setState({ triggerUserDeleteModal: false })}
            />
            <DeleteModal
              itemName={this.state.selectedUser.username}
              triggerModal={this.state.isDeleteInvitationModalActive}
              deleteItem={() => this.deleteInvitation()}
              deleteType={"User"}
              closeModal={() => this.setState({ isDeleteInvitationModalActive: false })}
            />
            <div className="kuika-settings-panel">
              <div className="kuika-settings-panel__header">
                <div className="kuika-settings-panel__header-left">
                  <KuikaSvg width={24} height={24} name="users-group" />
                  <KuikaH4 data-testid="userManagementPageTitle" data-onboarding-id="settings_users_page-title">
                    Team
                  </KuikaH4>
                </div>
                <div className="kuika-settings-panel__header-right">
                  <KuikaInput
                    data-testid="searchUserInput"
                    data-onboarding-id="settings_users_search-input"
                    onChange={this.filterUsers}
                    value={this.state.searchText}
                    placeholder="Search..."
                  />
                  {hasAccessInvite && (
                    <KuikaButton
                      data-testid="inviteButton"
                      data-onboarding-id="settings_users_invite"
                      onClick={() => this.openUserModalForCreate()}
                    >
                      INVITE
                    </KuikaButton>
                  )}
                </div>
              </div>
              <div className="kuika_management__users">
                <div className="kuika_table_wrapper kuika_users_table_wrapper">
                  {/* The table draws its own skeleton rows while the first list is on its way, so
                      nothing greys out the page around it any more (L7). */}
                  <KuikaTable<IUserDto>
                    data-testid="usersTable"
                    data-onboarding-id="settings_users_table"
                    data={
                      this.state.filteredUserList
                        ?.slice()
                        .sort((a: any, b: any) =>
                          a.isDomainOwner === true
                            ? -1
                            : b.isDomainOwner === true
                              ? 1
                              : (a.firstName?.localeCompare(b.firstName ?? "") ?? 0)
                        ) ?? []
                    }
                    columns={this.getTableColumns()}
                    rowKey={(row) => row.id}
                    pageSize={10}
                    loading={this.state.isDataLoading}
                    revealRowKey={this.state.revealUserId}
                    onRowRevealed={() => this.setState({ revealUserId: null })}
                    enableSorting
                    enableColumnVisibility
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showDomainAccessRequiredModal: (accessName) => dispatch(showDomainAccessRequiredModal(accessName))
  };
};

const users = connect(
  null,
  mapDispatchToProps
)(withContext<IUsersProps>(withManagement<IUsersProps>(withHistory<any>(Users))));
export { users as Users };
